import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  return (
    <header style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      background: 'rgba(255, 255, 255, 0.98)',
      backdropFilter: 'blur(10px)',
      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
      zIndex: 1000,
      padding: '1.25rem 0',
      borderBottom: '1px solid rgba(0, 0, 0, 0.05)'
    }}>
      <div style={{maxWidth: '1200px', margin: '0 auto', padding: '0 2rem'}}>
        <nav style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
          <Link to="/" style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.75rem',
            textDecoration: 'none',
            fontFamily: 'Inter, sans-serif',
            fontSize: '1.5rem',
            fontWeight: '800',
            color: '#0f172a'
          }}>
            <svg width="44" height="44" viewBox="0 0 44 44" fill="none">
              <defs>
                <linearGradient id="logoGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" style={{stopColor: '#3b82f6', stopOpacity: 1}} />
                  <stop offset="100%" style={{stopColor: '#1e40af', stopOpacity: 1}} />
                </linearGradient>
              </defs>
              <rect width="44" height="44" rx="10" fill="url(#logoGradient)"/>
              <path d="M14 30l8-16 8 16h-5l-3-6-3 6h-5z" fill="#ffffff"/>
              <circle cx="30" cy="14" r="4" fill="#fbbf24"/>
            </svg>
            <div style={{display: 'flex', flexDirection: 'column', lineHeight: '1.2'}}>
              <span style={{fontSize: '1.25rem'}}>Aramco Leads Pro</span>
              <span style={{fontSize: '0.65rem', color: '#64748b', fontWeight: '500', letterSpacing: '0.5px'}}>CRM & LEAD GENERATION</span>
            </div>
          </Link>
          
          <ul style={{
            display: 'flex',
            gap: '2.5rem',
            listStyle: 'none',
            margin: 0,
            padding: 0,
            alignItems: 'center'
          }} className="desktop-nav">
            <li><Link to="/" style={{color: location.pathname === '/' ? '#3b82f6' : '#64748b', textDecoration: 'none', fontWeight: '600', fontSize: '0.95rem', transition: 'color 0.3s', borderBottom: location.pathname === '/' ? '2px solid #3b82f6' : '2px solid transparent', paddingBottom: '0.25rem'}}>Home</Link></li>
            <li><Link to="/features" style={{color: location.pathname === '/features' ? '#3b82f6' : '#64748b', textDecoration: 'none', fontWeight: '600', fontSize: '0.95rem', transition: 'color 0.3s', borderBottom: location.pathname === '/features' ? '2px solid #3b82f6' : '2px solid transparent', paddingBottom: '0.25rem'}}>Features</Link></li>
            <li><Link to="/how-it-works" style={{color: location.pathname === '/how-it-works' ? '#3b82f6' : '#64748b', textDecoration: 'none', fontWeight: '600', fontSize: '0.95rem', transition: 'color 0.3s', borderBottom: location.pathname === '/how-it-works' ? '2px solid #3b82f6' : '2px solid transparent', paddingBottom: '0.25rem'}}>How It Works</Link></li>
            <li><Link to="/compliance" style={{color: location.pathname === '/compliance' ? '#3b82f6' : '#64748b', textDecoration: 'none', fontWeight: '600', fontSize: '0.95rem', transition: 'color 0.3s', borderBottom: location.pathname === '/compliance' ? '2px solid #3b82f6' : '2px solid transparent', paddingBottom: '0.25rem'}}>Compliance</Link></li>
            <li><Link to="/about" style={{color: location.pathname === '/about' ? '#3b82f6' : '#64748b', textDecoration: 'none', fontWeight: '600', fontSize: '0.95rem', transition: 'color 0.3s', borderBottom: location.pathname === '/about' ? '2px solid #3b82f6' : '2px solid transparent', paddingBottom: '0.25rem'}}>About</Link></li>
          </ul>
          
          <Link to="/contact" style={{
            padding: '0.875rem 2rem',
            background: 'linear-gradient(135deg, #3b82f6 0%, #1e40af 100%)',
            color: '#ffffff',
            borderRadius: '10px',
            textDecoration: 'none',
            fontWeight: '700',
            fontSize: '0.95rem',
            transition: 'all 0.3s ease',
            boxShadow: '0 4px 14px rgba(59, 130, 246, 0.4)',
            border: 'none'
          }} className="cta-button">
            Get Started →
          </Link>
          
          <div 
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            style={{
              display: 'none',
              flexDirection: 'column',
              gap: '4px',
              cursor: 'pointer'
            }}
            className="mobile-menu-btn"
          >
            <span style={{width: '25px', height: '3px', background: '#fff', borderRadius: '2px'}}></span>
            <span style={{width: '25px', height: '3px', background: '#fff', borderRadius: '2px'}}></span>
            <span style={{width: '25px', height: '3px', background: '#fff', borderRadius: '2px'}}></span>
          </div>
        </nav>
        
        {mobileMenuOpen && (
          <div style={{
            display: 'none',
            flexDirection: 'column',
            gap: '1rem',
            marginTop: '1rem',
            padding: '1rem',
            background: 'rgba(255,255,255,0.1)',
            borderRadius: '8px'
          }} className="mobile-nav">
            <Link to="/" onClick={() => setMobileMenuOpen(false)} style={{color: '#fff', textDecoration: 'none', padding: '0.5rem'}}>Home</Link>
            <Link to="/features" onClick={() => setMobileMenuOpen(false)} style={{color: '#fff', textDecoration: 'none', padding: '0.5rem'}}>Features</Link>
            <Link to="/how-it-works" onClick={() => setMobileMenuOpen(false)} style={{color: '#fff', textDecoration: 'none', padding: '0.5rem'}}>How It Works</Link>
            <Link to="/compliance" onClick={() => setMobileMenuOpen(false)} style={{color: '#fff', textDecoration: 'none', padding: '0.5rem'}}>Compliance</Link>
            <Link to="/about" onClick={() => setMobileMenuOpen(false)} style={{color: '#fff', textDecoration: 'none', padding: '0.5rem'}}>About</Link>
            <Link to="/contact" onClick={() => setMobileMenuOpen(false)} style={{color: '#fff', textDecoration: 'none', padding: '0.5rem'}}>Get Started</Link>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
